export const Sparkle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_102_2228)">
      <path
        d="M7.57876 15.9816L2.73563 14.2003C2.59322 14.1477 2.47035 14.0528 2.38356 13.9282C2.29677 13.8037 2.25024 13.6555 2.25024 13.5037C2.25024 13.3519 2.29677 13.2038 2.38356 13.0792C2.47035 12.9547 2.59322 12.8598 2.73563 12.8072L7.57876 11.0259C7.6796 10.989 7.77118 10.9305 7.84711 10.8546C7.92305 10.7787 7.98152 10.6871 8.01844 10.5862L9.79969 5.74312C9.85226 5.60071 9.94721 5.47784 10.0718 5.39105C10.1963 5.30426 10.3445 5.25774 10.4963 5.25774C10.6481 5.25774 10.7962 5.30426 10.9208 5.39105C11.0453 5.47784 11.1403 5.60071 11.1928 5.74312L12.9741 10.5862C13.011 10.6871 13.0695 10.7787 13.1454 10.8546C13.2213 10.9305 13.3129 10.989 13.4138 11.0259L18.2569 12.8072C18.3993 12.8598 18.5222 12.9547 18.609 13.0792C18.6957 13.2038 18.7423 13.3519 18.7423 13.5037C18.7423 13.6555 18.6957 13.8037 18.609 13.9282C18.5222 14.0528 18.3993 14.1477 18.2569 14.2003L13.4138 15.9816C13.3129 16.0185 13.2213 16.077 13.1454 16.1529C13.0695 16.2288 13.011 16.3204 12.9741 16.4212L11.1928 21.2644C11.1403 21.4068 11.0453 21.5297 10.9208 21.6164C10.7962 21.7032 10.6481 21.7498 10.4963 21.7498C10.3445 21.7498 10.1963 21.7032 10.0718 21.6164C9.94721 21.5297 9.85226 21.4068 9.79969 21.2644L8.01844 16.4212C7.98152 16.3204 7.92305 16.2288 7.84711 16.1529C7.77118 16.077 7.6796 16.0185 7.57876 15.9816Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 1.5V6"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 6.75V9.75"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 3.75H18.75"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 8.25H22.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_102_2228">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
